export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler, useCapture = false) {
      if (element && event && handler) {
        element.addEventListener(event, handler, useCapture)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()

export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler, useCapture = false) {
      if (element && event) {
        element.removeEventListener(event, handler, useCapture)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()

const trim = function (string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '')
}

/* istanbul ignore next */
export function addClass(el, cls) {
  if (!el) return
  var curClass = el.className
  var classes = (cls || '').split(' ')

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i]
    if (!clsName) continue

    if (el.classList) {
      el.classList.add(clsName)
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName
    }
  }
  if (!el.classList) {
    el.setAttribute('class', curClass)
  }
}

/* istanbul ignore next */
export function removeClass(el, cls) {
  if (!el || !cls) return
  var classes = cls.split(' ')
  var curClass = ' ' + el.className + ' '

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i]
    if (!clsName) continue

    if (el.classList) {
      el.classList.remove(clsName)
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ')
    }
  }
  if (!el.classList) {
    el.setAttribute('class', trim(curClass))
  }
}

export function hasClass(el, cls) {
  if (!el || !cls) return false
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.')
  if (el.classList) {
    return el.classList.contains(cls)
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1
  }
}

// export function createRangeToMeasureOverflowWidth(event) {
//   const range = document.createRange()
//   range.setStart(event.target, 0)
//   range.setEnd(event.target, event.target.childNodes.length)
//   const rangeWidth = Math.round(range.getBoundingClientRect().width)
//   const padding =
//     (Number.parseInt(window.getComputedStyle(event.target).paddingLeft, 10) || 0) +
//     (Number.parseInt(window.getComputedStyle(event.target).paddingRight, 10) || 0)
//   const isOverflow =
//     rangeWidth + padding > event.target.offsetWidth || event.target.scrollWidth > event.target.offsetWidth
//   return isOverflow
// }
/**
 *
 * @description 获取padding
 * @param {*} el
 * @return {*}
 */
const getPadding = el => {
  const style = window.getComputedStyle(el, null)
  const paddingLeft = Number.parseInt(style.paddingLeft, 10) || 0
  const paddingRight = Number.parseInt(style.paddingRight, 10) || 0
  const paddingTop = Number.parseInt(style.paddingTop, 10) || 0
  const paddingBottom = Number.parseInt(style.paddingBottom, 10) || 0
  return { left: paddingLeft, right: paddingRight, top: paddingTop, bottom: paddingBottom }
}

const isGreaterThan = (a, b, epsilon = 0.03) => {
  return a - b > epsilon
}

/**
 *
 * @description 判断是否溢出水平或垂直
 * @param {*} elementNode
 */
export function createRangeToMeasureOverflowWidth(elementNode, direction = 'horizontal') {
  const range = document.createRange()
  range.setStart(elementNode, 0)
  range.setEnd(elementNode, elementNode.childNodes.length)
  const rangeInfo = range.getBoundingClientRect()
  let rangeWidth = rangeInfo.width
  let rangeHeight = rangeInfo.height
  const cellInfo = elementNode.getBoundingClientRect()
  let cellWidth = cellInfo.width
  let cellHeight = cellInfo.height
  const { top, left, right, bottom } = getPadding(elementNode)
  const horizontalPadding = left + right
  const verticalPadding = top + bottom
  const scrollWidthOverflow = isGreaterThan(elementNode.scrollWidth, cellWidth)
  const horizontal = isGreaterThan(rangeWidth + horizontalPadding, cellWidth) || scrollWidthOverflow
  const vertical = isGreaterThan(rangeHeight + verticalPadding, cellHeight) || scrollWidthOverflow
  switch (direction) {
    case 'horizontal':
      return horizontal
    case 'vertical':
      return vertical
    case 'both':
      return vertical && horizontal
    default:
      break
  }
}

export function selectNodeContents(node) {
  try {
    const range = document.createRange()
    range.selectNodeContents(node)
    const selection = window.getSelection()
    selection.removeAllRanges()
    setTimeout(() => selection.addRange(range))
  } catch (e) {
    console.log(e)
  }
}

let measurementCanvasCtx = null
export function getMeasureTextWidthCanvas(text) {
  if (!text) {
    return 0
  }
  if (!measurementCanvasCtx) {
    const measurementCanvas = document.createElement('canvas')
    measurementCanvasCtx = measurementCanvas.getContext('2d')
    const font = `14px ${window.__erp_global_font__}, "Microsoft Yahei", 微软雅黑, "Microsoft Sans Serif", sans-serif`
    measurementCanvasCtx.font = font
  }
  const width = measurementCanvasCtx.measureText(text).width
  return parseInt(width)
}

export function removeMeasurementSpanCanvas() {
  if (measurementCanvasCtx) {
    measurementCanvasCtx = null
  }
}

export function byteLength(text) {
  let len = 0
  const str = String(text)
  if (!str) {
    return len
  }
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i)
    if (charCode <= 255) {
      len += 1
    } else {
      len += 2 // 非ASCII字符（例如中文）
    }
  }
  return len
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/utils/dom.js